export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9525.73d43343.jpg";